import { Button } from "@mantine/core";

import { IconCircleMinus } from "@tabler/icons-react";

export interface RemoveFromEligibilityListButtonProps {
  appointmentId: string;
  /** Appointment date and time as shown in the row, so each Remove button has its own name. */
  appointmentLabel: string;
  clientName: string;
  onRemoveFromList: () => void;
}

/**
 * Removes an appointment from the practice eligibility list.
 */
export default function RemoveFromEligibilityListButton({
  appointmentId,
  appointmentLabel,
  clientName,
  onRemoveFromList,
}: RemoveFromEligibilityListButtonProps) {
  return (
    <Button
      px="xs"
      c="red.7"
      variant="transparent"
      onClick={onRemoveFromList}
      leftSection={<IconCircleMinus size={16} />}
      data-testid={`eligibility-table-remove-${appointmentId}`}
      aria-label={`Remove ${clientName}'s appointment on ${appointmentLabel} from eligibility list`}
    >
      Remove
    </Button>
  );
}
